import {
  BID_ASK_COLORS,
  CHART_SERIES_PALETTE,
} from "./chart-palette";

export const PIE_COLORS = CHART_SERIES_PALETTE;

export const LIQUIDITY_CHARTS = {
  TOKEN_PAIRS: PIE_COLORS,
  DEX: PIE_COLORS,
  BID_AND_ASK: BID_ASK_COLORS,
};

export default LIQUIDITY_CHARTS;
